/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import Quill from 'quill';

interface EmbedBlotInstance {
  domNode: HTMLElement;
  format(name: string, value: any): void;
}

interface EmbedBlotConstructor {
  new (): EmbedBlotInstance;
  blotName: string;
  tagName: string;
  className: string;
  create(value: any): MergeTagBlotNode;
  formats(node: HTMLElement): any;
}

const Embed = Quill.import('blots/embed') as EmbedBlotConstructor;

interface MergeTagBlotNode extends HTMLElement {
  dataset: {
    tag: string;
  };
}

export class MergeTagBlot extends Embed {
  static blotName = 'mergeTag';
  static tagName = 'span';
  static className = 'merge-tag';

  static create(tag: string): MergeTagBlotNode {
    const node = super.create(tag);
    node.dataset.tag = tag;
    node.textContent = tag;
    node.classList.add(
      MergeTagBlot.className,
      'inline-block',
      'bg-blue-100',
      'text-blue-800',
      'rounded-full',
      'px-1',
      'py-0.5',
      'align-middle',
      'font-medium',
      'text-2xs',
      'select-none',
      'transition-all',
      'duration-250'
    );

    const deleteButton = this.makeDeleteButton();
    deleteButton.addEventListener('click', e => this.handleDeleteButtonClick(e, node));
    deleteButton.addEventListener('mouseenter', () => node.classList.add('bg-red-100', 'text-grey-700'));
    deleteButton.addEventListener('mouseleave', () => node.classList.remove('bg-red-100', 'text-grey-700'));

    node.appendChild(deleteButton);

    return node;
  }

  static handleDeleteButtonClick(e: PointerEvent, node: MergeTagBlotNode) {
    e.preventDefault();
    e.stopPropagation();

    node.classList.add('scale-40');
    setTimeout(() => node.remove(), 150);
  }

  static makeDeleteButton() {
    const deleteButton = document.createElement('button');
    deleteButton.textContent = '×';
    deleteButton.type = 'button';
    deleteButton.classList.add(
      'inline-block',
      'ml-0.5',
      'w-4',
      'h-4',
      'text-black',
      'hover:bg-red-500',
      'hover:text-white',
      'rounded-full',
      'flex',
      'items-center',
      'justify-center',
      'cursor-pointer',
      'transition-colors',
      'duration-250'
    );

    return deleteButton;
  }

  static value(node: HTMLElement) {
    return node.dataset.tag ?? '';
  }

  static formats(node: MergeTagBlotNode): string {
    return node.dataset.tag ?? '';
  }

  format(name: string, value: any) {
    if (name === MergeTagBlot.blotName && value) {
      this.domNode.dataset.tag = value;
      this.domNode.innerText = value;
    } else {
      super.format(name, value);
    }
  }
}
